module.exports = __webpack_public_path__ + "img/1280.7d73b00c.svg";